import React from "react";

const STYLE = {
  approved: { color: "text-[#EAB308]", bg: "bg-[#EAB308]/10", border: "border-[#EAB308]/40", dot: "bg-[#EAB308]" },
  verified_at_sign: { color: "text-[#EAB308]", bg: "bg-[#EAB308]/10", border: "border-[#EAB308]/40", dot: "bg-[#EAB308]" },
  verified: { color: "text-[#EAB308]", bg: "bg-[#EAB308]/10", border: "border-[#EAB308]/40", dot: "bg-[#EAB308]" },
  refuse: { color: "text-slate-300", bg: "bg-white/[0.04]", border: "border-white/20", dot: "bg-slate-400" },
  simulated: { color: "text-slate-300", bg: "bg-white/[0.04]", border: "border-white/20", dot: "bg-slate-400" },
  unverified: { color: "text-slate-400", bg: "bg-white/[0.02]", border: "border-white/10", dot: "bg-slate-500" },
};

export const ReceiptCard = ({ receipt }) => {
  const v = STYLE[receipt.verification_status] || STYLE.unverified;

  return (
    <article
      data-testid="receipt-card"
      className="border border-white/[0.08] bg-[#020B14]"
    >
      <header className="flex flex-wrap items-center justify-between gap-3 px-6 py-4 border-b border-white/[0.06]">
        <div className="flex items-center gap-3">
          <span className="mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            KATLAS Receipt
          </span>
          <span
            data-testid="receipt-hash"
            className="mono text-xs text-slate-300"
          >
            {receipt.hash}
          </span>
        </div>
        <span
          data-testid="receipt-status"
          className={`inline-flex items-center gap-1.5 px-2 py-1 border mono text-[10px] uppercase tracking-[0.18em] ${v.color} ${v.bg} ${v.border}`}
        >
          <span className={`w-1.5 h-1.5 ${v.dot}`} />
          {receipt.verification_status.replace(/_/g, " ")}
        </span>
      </header>

      <div className="grid sm:grid-cols-2 gap-px bg-white/[0.06]">
        <Row k="Action" v={receipt.action} testId="receipt-action" />
        <Row k="Decision" v={receipt.decision} accent={receipt.decision === "approve"} testId="receipt-decision" />
        <Row k="Custody (subject)" v={receipt.custody_subject_ref} testId="receipt-custody" />
        <Row k="Authority (role)" v={receipt.authority_role} testId="receipt-authority" />
        <Row k="Signer" v={receipt.signer_ref || "—"} testId="receipt-signer" />
        <Row k="Signer fingerprint" v={receipt.signer_fingerprint || "—"} testId="receipt-fingerprint" />
        <Row k="Node timestamp" v={receipt.node_timestamp || "—"} testId="receipt-timestamp" />
        <Row k="Attestation ref" v={receipt.attestation_ref || "—"} testId="receipt-attref" />
      </div>

      <div className="grid sm:grid-cols-2 gap-px bg-white/[0.06] border-t border-white/[0.06]">
        <div className="bg-[#020B14] p-5">
          <div className="mono text-[10px] uppercase tracking-[0.2em] text-[#0066FF]">
            Shared evidence
          </div>
          <ul
            data-testid="receipt-shared-evidence"
            className="mt-3 space-y-2 mono text-xs text-slate-200"
          >
            {receipt.shared_evidence_refs.map((r) => (
              <li key={r} className="flex items-center gap-2">
                <span className="w-1 h-1 bg-[#0066FF]" />
                {r}
              </li>
            ))}
            {receipt.shared_evidence_refs.length === 0 && (
              <li className="text-slate-500">None</li>
            )}
          </ul>
        </div>
        <div className="bg-[#020B14] p-5">
          <div className="mono text-[10px] uppercase tracking-[0.2em] text-[#EAB308]">
            Withheld evidence
          </div>
          <div
            data-testid="receipt-withheld-count"
            className="mt-3 mono text-3xl text-white"
          >
            {receipt.withheld_evidence_count}
          </div>
          <p className="mt-1 text-xs text-slate-500">
            items kept within custody, never sent to the KATLAS node.
          </p>
        </div>
      </div>

      <footer className="px-6 py-5 border-t border-white/[0.06] space-y-3">
        <p
          data-testid="receipt-statement"
          className="text-sm text-white leading-relaxed"
        >
          {receipt.receipt_statement}
        </p>
        <p
          data-testid="receipt-data-boundary"
          className="text-xs text-slate-500 leading-relaxed italic"
        >
          {receipt.data_boundary_statement}
        </p>
      </footer>
    </article>
  );
};

const Row = ({ k, v, accent, testId }) => (
  <div className="bg-[#020B14] p-4">
    <div className="mono text-[10px] uppercase tracking-[0.18em] text-slate-500">
      {k}
    </div>
    <div
      data-testid={testId}
      className={`mt-1 mono text-sm ${accent ? "text-[#EAB308]" : "text-slate-200"} break-all`}
    >
      {v}
    </div>
  </div>
);
